import React from 'react'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'

export default function CopyableId({ value, label = 'ID', className = '' }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
    } catch (e) {
      // no-op
    }
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && <span className="text-xs text-gray-500">{label}</span>}
      <span className="font-mono text-sm text-gray-900 break-all">{value}</span>
      <button
        type="button"
        onClick={copy}
        className="p-1 rounded hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-psg-teal"
        aria-label="Copy ID"
        title="Copy"
      >
        <DocumentDuplicateIcon className="h-4 w-4 text-gray-500" />
      </button>
    </div>
  )
}


